<template>
  <div class="favorite-sidebar" :class="{'active': this.favoritesVisible}">

    <button type="button" class="close" @click="TOGGLE_FAVORITE_SIDEBAR">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17">
        <path fill="#ffffff" d="M16.988 15.547l-1.442 1.442-7.047-7.047-7.047 7.047-1.441-1.442L7.058 8.5.011 1.453 1.452.011l7.047 7.047L15.546.011l1.442 1.442L9.941 8.5l7.047 7.047z"/>
      </svg>
    </button>

    <ul class="list optiscroll">
      <li
        is="FavoritesList"
        v-for="item in catsForList"
        :key="item.id"
        :item="item"
        :isRadioStation="isRadioStation"
      >
      </li>
    </ul>

  </div>
</template>

<script>
import FavoritesList from 'components/FavoritesList'
import Optiscroll from 'optiscroll'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FavoritesSidebar',
  props: {
    isRadioStation: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FavoritesList,
    Optiscroll
  },
  computed: {
    ...mapState({
      tvCategories: state => state.guide.tvCategories,
      radioCategories: state => state.guide.radioCategories,
      favoritesVisible: state => state.guide.favoritesVisible
    }),
    catsForList () {
      return this.isRadioStation ? this.radioCategories : this.tvCategories
    },
    catsForListLoaded () {
      return this.catsForList.length > 0
    }
  },
  methods: {
    ...mapMutations([
      'TOGGLE_FAVORITE_SIDEBAR'
    ])
  },
  mounted: function () {
    if (this.catsForListLoaded) {
      this.$nextTick(() => {
        this.catsScroll = new Optiscroll(this.$el.querySelector('.list'))
      })
    }
  },
  watch: {
    catsForListLoaded () {
      this.$nextTick(() => {
        this.catsScroll = new Optiscroll(this.$el.querySelector('.list'))
      })
    }
  },
  beforeDestroy: function () {
    if (this.catsScroll) {
      this.catsScroll.destroy()
    }
  }
}
</script>

<style scoped lang="scss">
@import 'uc/_variables';

.favorite-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 355px;
    padding: 15px;
    background-color: rgb(32, 32, 32);
    transform: translate3d(-100%, 0, 0);
    perspective: 1000px;
    transition: transform 0.5s ease;
    z-index: 1100;

    &.active {
        transform: translate3d(0,0,0);
    }
}

.close {
    float: right;
    margin: -15px -15px 5px 0;
    padding: 15px;
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    outline: 0;

    svg {
        display: block;
        width: 15px;
        height: 15px;
        pointer-events: none;
    }
}

.list {
    clear: both;
    height: calc(100vh - 64px);
    margin-right: -8px;

    /deep/ .optiscroll-content {
        padding-right: 20px;
    }
}

@media only screen and (min-width: $breakpoint3) {
    .favorite-sidebar {
        width: 500px;
        padding: 20px;
    }
    .close {
        margin: -20px -20px 3px 0;
        padding: 20px;

        svg {
            width: 17px;
            height: 17px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FavoritesSidebar.vue